import { fetchPrintTypes } from '@/utils/http/fetchPrintTypes';
import { Thunk } from '@/redux/types';
import { CoreActionTypes, PrintTypeFetchAction } from '../types';

/**
 * Fetches print types for the current shop/user from the API, maps them and
 * sends an action to the store.
 */
export const fetchPrintTypesAction = (): Thunk<Promise<void>, PrintTypeFetchAction> => (dispatch) =>
  fetchPrintTypes().then((printTypes) => {
    dispatch({ type: CoreActionTypes.PRINT_TYPE_FETCH, printTypes });
  });
